@if (currentDocument(); as documento) {
<p-card [header]="documento.protocollo + ' del ' + (documento.dataProtocollazione | date:'dd/MM/yyyy')">
  @if(showToolbar()) {
  <app-visualizza-toolbar [editMode]="editMode()" [showReply]="true" [arrivo]="documento.arrivo" [isLocked]="documento.bloccato"
    (atti)="sendToArchive()" (declassify)="showDeclassification()" (edit)="editData()" (editNote)="editNote()"
    (changeState)="changeState()" (reply)="genera()" (createCopy)="copiaPer()" (link)="showRiferimenti()"
    (lock)="lock()" (unlock)="unlock()" (destroy)="showDistruzione()" (saveEdit)="saveEdit()" (undoEdit)="undoEdit()"
    (printLabel)="printLabel()" (sendToStateArchive)="showStateArchive()" (revoke)="showRevokeDialog()"
    (temporarySend)="showTemporarySend()" (moveFascicolo)="moveFascicolo()" (riproduzione)="showRiproduzione()"
    (transmit)="trasmettiAllegati()" (printReceipt)="stampaRicevuta()"
    (downloadAdminXml)="scaricaDocumentoAmministrativoXml()"
    (undoOperation)="undoOperation($event)" [operationsCanUndo]="operationsCanUndo()"
    [isDocInvalid]="datiDoc.invalid" [isRiproduzione]="documento.riproduzione" [isDocDestroyed] = "isDocDestroyed()"/>
  } @else if(showChangeState()) {
  <p-toolbar>
    <button *hasClaim="GassClaims.DocRiapertura" pButton type="button" title="Modifica stato"
      icon="fas fa-fw fa-exchange-alt" (click)="changeState()"></button>
  </p-toolbar>
  }
  <app-dati-documento [(ngModel)]="currentDocument" [posizione]="posizione$ | async" [disabled]="!editMode()"
    #datiDoc="ngModel" />
</p-card>

<p-card header="Allegati">
  <p-messages key="allegati"></p-messages>
  <app-allegati [allegati]="(allegati$ | async) ?? []" [documentId]="documento.documentoId"
    [tipoAllegato]="TipoAllegato.Allegato"
    [scannedFile]="scannedFile()" [scanInProgress]="scanInProgress()"
    [pendingScanRequestId]="pendingScanRequestId()" (scanCancelled)="cancelPendingScan()"
    [isLocked]="isBlocked()" [hasRiferimenti]="hasRiferimenti" [isDeparture]="!documento.arrivo"
    (uploadCompleted)="uploadCompleted()" (uploadError)="uploadError($event)" (scan)="scan()"
    (downloadFile)="openFile($event)" (deleteFile)="deleteFile($event)" (relaunchOCR)="relaunchOCR($event)"
    (modifyOCR)="modifyOCR($event)" (beforeUpload)="beforeUpload()" (setPrimaryAllegato)="setPrimaryAllegato($event)" (changeRiproduzione)="changeRiproduzione($event)"
    (showPassword)="showPassword($event)" (riproduciAllegati)="riproduciAllegati()" (allegatoToUpload)="showUploadAllegatoCondivisoDialog($event)"
    (allegatoToPreview)="allegatoPreview($event)" [updatingAllegati]="allegatiUpdating()"/>
  <div class="p-card-subheader">
    <span class="card-sub-header">Annessi</span>
  </div>
  <app-allegati [allegati]="(annessi$ | async) ?? []" [documentId]="documento.documentoId"
    [tipoAllegato]="TipoAllegato.Annesso" [showPrimaryCheckbox]="false" [showSharedFiles]="false"
    [isLocked]="isBlocked()" [hasRiferimenti]="hasRiferimenti" [isDeparture]="!documento.arrivo"
    (uploadCompleted)="uploadCompleted()" (uploadError)="uploadError($event)"
    (downloadFile)="openFile($event)" (deleteFile)="deleteFile($event)" (relaunchOCR)="relaunchOCR($event)"
    (modifyOCR)="modifyOCR($event)" (beforeUpload)="beforeUpload()" (changeRiproduzione)="changeRiproduzione($event)"
    (showPassword)="showPassword($event)" [updatingAllegati]="allegatiUpdating()"/>
  <div class="p-card-subheader">
    <span class="card-sub-header">CIS</span>
  </div>
  <app-cis-allegati [cis]="cis$ | async" [isLocked]="documento.bloccato" [isArrivo]="documento.arrivo" [isDocDestroyed]="isDocDestroyed()"
    (addCIS)="onShowAddCISDialog()" (distruggiCIS)="onDistruggiCIS($event)" (recuperaCIS)="onRecuperaCIS($event)"
    (restituisciCIS)="onRestituisciCIS($event)" (modifyCIS)="onShowModificaCISDialog($event)"/>
</p-card>

  @if(riproduzioni$ | async; as riproduzioni) {
    @if (riproduzioni.length > 0) {
      <p-card header="Riproduzioni">
        <app-riproduzioni-table [riproduzioni]="riproduzioni" (trasmetti)="showTrasmettiDialog($event)"
          (spedisci)="showSpedisciDialog($event)" (distruggiRipro)="distruggiRiproduzione($event)"
          (gestisciAllegatiRipro)="gestisciAllegatiRiproduzione($event)"
          (modificaRipro)="showModificaRiproduzioneDialog($event)" />
      </p-card>

      <app-trasmetti-riproduzioni-dialog [visible]="showTrasmettiRiproduzioniDialog()"
        [riproduzione]="riproduzioneDaTrasmettere" (hide)="showTrasmettiRiproduzioniDialog.set(false)"
        (saved)="trasmetti($event)" />
      <app-allegati-riproduzione-dialog [visible]="showAllegatiRiproduzioneDialog()" [allegati]="allegatiRiproduzione"
        [documentoRiproduzione]="allegatidocumentoRiproduzione" (hide)="onHideAllegatiRiproduzione()"
        (deleteFile)="deleteFile($event)" (changeRiproduzione)="changeRiproduzione($event)" />
      <app-modifica-riproduzione-dialog [riproduzione]="riproduzioneDaModificare" [visible]="showModificaRiproduzioniDialog()"
        (hide)="showModificaRiproduzioniDialog.set(false)" [destinatariArray]="destinatariArray"
        (modify)="modificaRiproduzione($event)" />
    }
  }

  @if(riferimenti$ | async; as riferimenti) {
    <p-card header="Riferimenti">
      <app-documenti-list [data]="riferimenti" [activeColumns]="riferimentiColumns" [showDeleteButton]="true"
        [allowPosizioneHierarchy]="false" [paginator]="false" (delete)="removeLink($event)" />
    </p-card>

    <app-partenza-riproduzione-dialog [riferimentiSearchResponse]="riferimenti.results"
      [visible]="showPartenzaRiproduzioneDialog()" (hide)="onHidePartenzaRiproduzione()"></app-partenza-riproduzione-dialog>
  }

  @if(copie$ | async; as copie) {
    @if(copie && copie.length > 0) {
      <p-card header="Copie">
        <app-tabella-copiaper [copie]="copie" (delete)="deleteCopy($event)" />
      </p-card>
    }
  }

  <p-card header="Registri">
    <app-registers-table [registri]="registri$ | async" />
  </p-card>

  <p-card header="Storico">
    <app-tabella-storici [documentHistory]="storico$ | async" [stati]="stati$ | async" />
  </p-card>

  <p-dialog #dialogcopia header="Crea copia nel fascicolo" [(visible)]="showCopyDialog" [modal]="true"
    [style]="{'width':'50%'}">
    <app-position-select [(ngModel)]="positionCopiaPer" #copiaSelect="ngModel" />
    <p-footer>
      <div class="flex justify-content-end">
        <button pButton type="button" icon="pi pi-times" label="Annulla" title="Annulla" (click)="clearCopyDialog()"
          class="p-button-secondary"></button>
        <button pButton type="button" icon="pi pi-check" label="Crea copia" title="Crea copia" (click)="addCopy()"
          [disabled]="copiaSelect.invalid"></button>
      </div>
    </p-footer>
  </p-dialog>

  <p-dialog header="Tipo di modifica" [(visible)]="showModificaDocumentoDialog" [modal]="true"
    (onHide)="onHideModificaDocumentoDialog()" [style]="{'width':'30%'}" [contentStyle]="{'min-height':'220px'}">
    <div class="p-fluid">
      <label class="small-label" for="tipoModifica">Tipo di modifica</label>
      <p-dropdown inputId="tipoModifica" [options]="tipoModificaOptions" [(ngModel)]="tipoModifica"
        placeholder="Seleziona"></p-dropdown>
    </div>
    <p-footer>
      <div class="flex justify-content-end">
        <button pButton type="button" icon="pi pi-check" label="Salva" title="Salva" (click)="confirmSaveEdit()"></button>
      </div>
    </p-footer>
  </p-dialog>

  <app-spostafascicolo-dialog [visible]="showSpostaFascicoloDialog()" (hide)="onHideSpostaFascicolo()"
    (confirm)="spostaFascicolo($event)" />
  <app-modifica-stato-dialog [visible]="showStateDialog()" [documentId]="documento.documentoId"
    (hide)="onHideStateDialog()" (done)="getDocumento()" />
  <app-riferimenti-dialog [visible]="showRiferimentiDialog()" (hide)="onHideRiferimenti()" (confirm)="addLink($event)" />
  <app-declassifica-dialog [visible]="showDeclassificaDialog()" [documentId]="documento.documentoId" [classifica]="documento.classificaId"
    [qualifica]="documento.qualificaId" (hide)="onHideDeclassifica()" (done)="getDocumento()" />
  <app-state-archive-dialog [visible]="showStateArchiveDialog()" [documentId]="documento.documentoId"
    (hide)="onHideStateArchiveDialog()" (done)="getDocumento()" />
  <app-distruzione-dialog [visible]="showDistruzioneDialog()" [documentId]="documentoIdDaDistruggere"
    [allegati]="distruzioneAllegato" (hide)="onHideDistruzione()" (done)="onDestroyDone()"
    (fail)="onDestroyFail($event)" />
  <app-revoca-dialog [visible]="revocaDialogVisible()" [documentId]="documento.documentoId" (hide)="onHideRevocaDialog()"
    (done)="onRevocaDone()" (fail)="onRevocaFail()" />
  <app-temporary-send-dialog [visible]="showTemporarySendDialog()" [documentId]="documento.documentoId"
    (hide)="onHideTemporarySendDialog()" (done)="getDocumento()" />
  <app-allegati-show-password [visible]="!!passwordAllegato()" [password]="passwordAllegato()"
    (hide)="onHideShowPassword()" />
  <app-riproduzioni-dialog [visible]="showRiproduzioniDialog()" [positionRiproduzione]="posizione$ | async"
    [documento]="documento" (hide)="hideRiproduzioneDialog()" (save)="addRiproduzione($event)" />
  <app-add-allegato-cis-dialog [arrivo]="documento.arrivo" [classificaDocumentoPadre]="currentClassifica"
    [qualificaDocumentoPadre]="currentQualifica" [visible]="showAddCISDialog()" (hide)="onHideAllegatoCIS()"
    (saved)="onSaveAllegatoCIS($event)" [allegatoCIS]="currentCisAllegato" />
  <app-distruzione-restituzione-cis-dialog [visible]="showUpdateCISDialog()" [distruzione]="isDistruzioneCIS()"
    [allegatoCIS]="currentCisAllegato" [documento]="documento" (hide)="onHideUpdateCISDialog()"
    (update)="onUpdateCIS($event)" />
  <app-modifica-note-dialog [visible]="showModificaNoteDialog()" [note]="documento.note" (hide)="onHideModificaNote()"
    (noteChanged)="onNoteChanged($event)" />
  <app-ricevuta-trasmissione-dialog [visible]="showRicevutaTrasmissioneDialog()" [documentId]="documento.documentoId"
    [destinatari]="documento.documentoDestinatario" (hide)="onHideRicevutaTrasmissione()" />
  <app-add-allegati-condivisi-dialog [visible]="showAllegatiCondivisiDialog()" [selectedAllegato]="allegatoCondivisoToUpload()" [allegati]="alleagatiCaricati()"
    (hide)="onHideUploadAllegatoCondivisoDialog()"
    (allegatoToUpload)="uploadAllegatiCondivisi($event)"/>
} @else {
  <p-card>
    <p class="text-lg text-center text-red-500">Documento non presente oppure non si dispongono delle autorizzazioni
      necessarie per visionarlo.</p>
  </p-card>
}
